export default __webpack_public_path__ + "static/media/tasksFilled.1e3e9dd0.svg";